import { Container } from "../../../UI/container/Container";
import { useColors } from "../../../../hooks/colors/useColors";
import {
  IconClock2,
  IconDeviceMobile,
  IconMail,
  IconMessage,
} from "@tabler/icons";
import { Grid, Text } from "@mantine/core";
import { useTranslation } from "next-i18next";

export function Address(props: { hideIFrame?: boolean }) {
  const { colors } = useColors();
  const { t } = useTranslation("common");
  return (
    <div style={{ backgroundColor: colors.background }} className="w-full p-0 ">
      <Container noHeight>
        <div className="w-full">
          <Grid className="w-full justify-center">
            <Grid.Col
              span={{ base: 12, md: 6, lg: 6 }}
              className="flex items-center gap-4 justify-center !sm:my-4 "
            >
              <Text size="lg" className="flex flex-col gap-2 justify-center">
                <div className="flex gap-2">
                  <IconClock2 color={colors.primary} size={30} />
                  <b>{t("ops-hours")}</b>
                </div>
                <span
                  // @ts-ignore
                  dangerouslySetInnerHTML={{ __html: t("hours") }}
                />
              </Text>
            </Grid.Col>
            <Grid.Col
              span={{ base: 12, md: 6, lg: 6 }}
              className="flex justify-center ml-4"
            >
              <Text size="lg" className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <IconMessage color={colors.primary} size={30} />
                  <b>{t("contacts-joao-parente")}</b>
                </div>
                <a href="tel:910646434" className="flex items-center gap-2">
                  <IconDeviceMobile color={colors.primary} size={30} />
                  <div>
                    +351 928 332 634
                    <p className="!my-0">{t("call-local")}</p>
                  </div>
                </a>
                <a
                  href="mailto:geral@psiworks.pt"
                  className="flex items-center gap-2"
                >
                  <IconMail color={colors.primary} size={30} />
                  geral@psiworks.pt
                </a>
              </Text>
            </Grid.Col>
          </Grid>
        </div>
      </Container>
    </div>
  );
}
